import React from "react";
import project1 from "./Images/laptop_project1.png";
import project2 from "./Images/laptop.png";
import project3 from "./Images/laptop.png";
import project4 from "./Images/laptop.png";
import { openInNewTab } from "./Helper/helper";
import { FaGithub } from "react-icons/fa";
import { useNavigate } from "react-router";
//transition-opacity duration-500 opacity-0 group-hover:opacity-100
//bg color - image
function Project(props) {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col lg:flex-row lg:min-h-40 lg:max-h-40 gap-2">
            <div
                onClick={() => navigate(props.project.routeURL)}
                className="flex-1 hover:cursor-pointer"
            >
                <img
                    className="object-contain object-fill min-h-full rounded "
                    src={props.project.projectImage}
                ></img>
            </div>
            <div className="flex-1 flex flex-col lg:gap-3">
                <div>{props.project.projectName}</div>
                <div className="flex-1 text-sm font-roboto">
                    {props.project.overview}
                </div>
                <div className="flex items-center">
                    <div
                        onClick={() => openInNewTab(props.project.github)}
                        className="p-1 mr-2 hover:cursor-pointer hover:scale-125 transition-all"
                    >
                        <FaGithub />
                    </div>
                    <div
                        onClick={() => {
                            navigate(props.project.routeURL);
                        }}
                        className="flex items-center opacity-60 text-sm transition-all hover:cursor-pointer hover:opacity-100 font-sourcecodepro"
                    >
                        Read more &rarr;
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Project;
